import React from "react";
import DynamicImport from "components/v3/dynamic-import/DynamicImport";

const PayPalButton = (props) => {
    return (
        <DynamicImport
            name="PayPalButton"
            importComponent={ () => import(/* webpackChunkName: "paypalButton" */ "components/v3/paypal-button/WrappedButton") }
            { ...props }
        />
    );
};

export default PayPalButton;
